import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import Dialog from '@material-ui/core/Dialog';
import Transition from '../dialogs/Transition';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Zoom from '@material-ui/core/Zoom';

import _ from "lodash";
import { withStyles } from '@material-ui/core/styles';
import Button from "@material-ui/core/Button";

//- graphics
import CircularProgress from "@material-ui/core/CircularProgress";
import GreenChecked from '../../images/icons/greenChecked.svg';
import AuthUserContainer from "../../containers/AuthUser";
import TmwApiContainer from "../../containers/Ticket/TmwApi";
import FormTextArea from "../form/FormTextArea";

function styles () {
	return {
		inner: {
			padding: '40px 30px',
		},
		dialogTitle : {
			fontSize : 20,
			borderBottom : '1px solid #eee',
			paddingBottom : 5,
			marginBottom : 10,
			fontWeight : 300,
			display : 'flex',
			justifyContent : 'space-between',
		},
		dialogRoot: {
			//overflow: 'visible'
			alignItems : 'end'
		},
		closeButton: {
			position: 'absolute',
			right: 15,
			top: 15,
			color: '#555',
		},
		addButton : {
			//verticalAlign : 'middle',
			//textDecoration: 'none',
			//marginBottom: 0,
			//borderRadius: 100,
			padding: '10px 35px',
			fontSize : 16,
			marginTop : 20,
			color : 'white',
			marginRight : 10,
		},
		greenCheckedIcon : {
			display: 'inline-block',
			width: 33,
			height: 33,
			backgroundImage: `url('${GreenChecked}')`,
			backgroundPosition: 'center',
			backgroundSize: 'cover',
			verticalAlign: 'middle',
			marginRight : 2,
			marginLeft : 5,
		},
		isSaving : {
			marginLeft : 20,
			fontSize : 16,
			color : '#1565C0',
		},
		savingSuccessful : {
			marginLeft : 20,
			fontSize : 16,
			color : '#2E7D32',
		}
	};
}

class UnbilledAddCommentDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formFieldError: {},
			isSaving : false,
			savingSuccessful : false,
			closingIn : 3,
		};
	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const { userAssignmentToEnd} = this.props;

		if (userAssignmentToEnd !== prevProps.userAssignmentToEnd) {
			const { endDate} = userAssignmentToEnd;
			if (!endDate) { return; }
			this.setState({
				endDate,
			});
		}

		if (this.state.closingIn === 0 && prevState.closingIn === 1) {
			this.props.onClose();
			this.setState({
				savingSuccessful : false,
				commentText : '',
			});
		}
	}

	getInputProps = (path, defaultValue) => {
		return {
			key : path,
			path,
			value  : this.getValue(path, defaultValue),
			checked  : this.getValue(path, defaultValue),
			error : this.getError(path),
			onChange : this.onChange,
			gridProps : { md : 12 },
		};
	};

	getValue  = (path, defaultValue) => {
		const _d = (_.isUndefined(defaultValue)) ? '' : defaultValue;
		return _.get(this.state, path, _d);
	};

	getError = (path) => {
		return _.get(this.state.formFieldError, path);
	};

	onChange = (value, path, error) => {
		const arrayPath = _.toPath(path);
		const basePath = _.head(arrayPath);
		let base = this.state[basePath];
		let newState = {};

		if (_.isArray(base) || _.isObject(base)) {
			if (arrayPath.length > 1) {
				base = _.cloneDeep(base);
				_.set(base, arrayPath.slice(1), value);
				newState[basePath] = base;
			} else {
				newState[basePath] = value;
			}
		} else {
			newState[basePath] = value;
		}

		//- Clear any errors on the path
		let formFieldError = Object.assign({}, this.state.formFieldError);

		if (error) {
			formFieldError[path] = error;
		} else {
			delete formFieldError[path];
		}
		newState.formFieldError = formFieldError;
		this.setState(newState);
	};

	submitAddComment = () => {
		const {
			addTmwOrderComment,
			afterSave,
			tmwOrder,
			showErrors} = this.props;

		this.setState({ isSaving: true, savingSuccessful : false });

		const { tmwOrderId } = tmwOrder;

		const {
			commentText,
		} = this.state;

		if (!commentText) {
			this.setState({ isSaving : false });
			return showErrors("Comment required");
		}

		const params = {
			tmwOrderId,
			commentText,
		};

		addTmwOrderComment({
			params,
			callback: (err, apiResult) => {
				if (err) {
					this.setState({ isSaving : false });
					showErrors(err);
					return;
				}

				this.setState({
					isSaving : false,
					closingIn : 1,
					savingSuccessful : true
				});
				afterSave({ apiResult });
				_.delay(() => { this.setState({closingIn : 0}); }, 300);
			}
		});
	};

	render() {
		const {
			open,
			onClose,
			classes,
			tmwOrder
		} = this.props;

		if (!tmwOrder) {
			return (
				<Dialog
					open={open}
					TransitionComponent={Transition}
					onClose={onClose}
				>
					<div className={classes.inner}>
						Sorry missing tmwOrder. Please refresh???
					</div>
				</Dialog>
			);
		}

		const { tmwOrderId } = tmwOrder;
		const { isSaving, savingSuccessful} = this.state;
		return (
			<Dialog
				open={open}
				TransitionComponent={Transition}
				onClose={onClose}
				fullWidth={true}
				maxWidth={'md'}
				classes={{ scrollPaper : classes.dialogRoot }}
			>
				<div className={classes.inner}>
					<div className={classes.dialogTitle}>
						<div>
							Add comment to TMW Order Id #<strong>{tmwOrderId}</strong>
						</div>
						<div>
							<IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
								<CloseIcon />
							</IconButton>
						</div>
					</div>

					<form>
						<Grid container spacing={2} style={{marginTop : 0, marginBottom : 0}}>
							<Grid item xs={12}>
								<FormTextArea
									{...this.getInputProps('commentText')}
									label={'Comment'}
									rows={2}
								/>
							</Grid>

							<Grid item md={12} style={{display : 'flex', alignItems : 'baseline'}}>
								<Button
									variant="contained"
									color="primary"
									className={classes.addButton}
									onClick={this.submitAddComment}
									disabled={isSaving || savingSuccessful}
								>
									Add Comment
								</Button>

								<Button variant="outlined" className={classes.button} onClick={onClose}>
									Close
								</Button>

								<Zoom
									in={isSaving}
									style={{ transitionDelay: isSaving ? '0ms' : '0ms' }}
									mountOnEnter unmountOnExit
								>
									<div className={classes.isSaving}>
										<CircularProgress style={{verticalAlign : 'middle'}} />
										<span style={{paddingLeft: 10}}>Saving...</span>
									</div>
								</Zoom>

								<Zoom in={savingSuccessful} style={{ transitionDelay: savingSuccessful ? '100ms' : '0ms' }}>
									<div className={classes.savingSuccessful}>
										<div className={classes.greenCheckedIcon}/>
										<span style={{paddingLeft: 10}}>Save Successful.</span>
									</div>
								</Zoom>
							</Grid>
						</Grid>
					</form>
				</div>
			</Dialog>
		);
	}
}

UnbilledAddCommentDialog.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func,
	addTmwOrderComment : PropTypes.func,
	tmwOrder : PropTypes.object,
	afterSave : PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles, { withTheme: true }),
	AuthUserContainer,
	TmwApiContainer,
])(UnbilledAddCommentDialog);
